webpackJsonp([18766721921915],{

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(11);
	
	var _banner = __webpack_require__(67);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _metadata = __webpack_require__(42);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _footer = __webpack_require__(41);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _styles2 = __webpack_require__(243);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PolicyContent = function PolicyContent(_ref) {
	  var policy = _ref.policy,
	      metadata = _ref.metadata,
	      classes = _ref.classes,
	      policies = _ref.policies;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_metadata2.default, { data: metadata }),
	    _react2.default.createElement(_banner2.default, { uid: 'policy', title: policy.title, subtitle: policy.subtitle }),
	    _react2.default.createElement(
	      'div',
	      { className: classes.contents },
	      _react2.default.createElement(
	        'div',
	        { className: classes.centred },
	        policy.text.map(function (item) {
	          return _react2.default.createElement('div', {
	            dangerouslySetInnerHTML: { __html: item && item.html },
	            className: classes.text
	          });
	        })
	      )
	    ),
	    _react2.default.createElement(_footer2.default, { policies: policies })
	  );
	};
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(PolicyContent);
	module.exports = exports['default'];

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _mixins = __webpack_require__(31);
	
	var styles = function styles(theme) {
	  return {
	    centred: _extends({}, (0, _mixins.Centred)(theme)),
	    contents: _extends({}, (0, _mixins.Contents)(theme)),
	    text: _extends({}, (0, _mixins.RichText)(theme)),
	    policyContents: {
	      width: '100%',
	      height: '100%',
	      marginLeft: 'auto',
	      marginRight: 'auto'
	
	    },
	
	    policyCentered: {
	      width: '100%',
	      height: '100%',
	      display: 'flex',
	      padding: '3rem 3rem 0 3rem',
	      flexGrow: 1,
	      flexWrap: 'wrap',
	      alignItems: 'center',
	      justifyContent: 'center'
	    },
	    allpoliciescontent: _extends({}, (0, _mixins.RichText)(theme)),
	
	    h1text: {
	      fontSize: '2.1rem',
	      fontWeight: 600,
	      color: 'rgba(0,0,0,.7)',
	      fontFamily: theme.typography.body1.fontFamily,
	      marginTop: theme.spacing.unit * 5,
	      marginBottom: theme.spacing.unit * 5
	    },
	    link: {
	      textDecoration: 'none'
	
	    }
	
	  };
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fragments = __webpack_require__(46);
	
	var _mapper = __webpack_require__(38);
	
	var _metadata = __webpack_require__(42);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _policy = __webpack_require__(592);
	
	var _policy2 = _interopRequireDefault(_policy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Policy = function Policy(props) {
	  var metadata = (0, _mapper.mapMetaData)(props.data.doc);
	  var policy = (0, _mapper.mapPolicy)(props.data.doc);
	
	  return _react2.default.createElement(_policy2.default, { policy: policy, metadata: metadata, policies: props.data.policies.edges });
	};
	
	exports.default = Policy;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-policies-policy-js-3c1d491f345b0193a28e.js